import React from 'react';
import { makeStyles } from '@material-ui/core';

import { Button, Typography, units } from '@ha/dsl';

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: units.rem(1.875),
    display: 'inline-flex',
  },
  text: {
    marginLeft: units.rem(1),
    maxWidth: units.rem(16.875),
  },
}));

interface Props {
  icon: React.ReactElement;
  title: string;
  caption: string;
  url: string;
  noFollow: boolean;
}

const DropdownMenuItem: React.FC<Props> = ({
  icon,
  title,
  caption,
  url,
  noFollow,
}) => {
  const classes = useStyles();

  return (
    <Button
      variant="text"
      iconSize="large"
      href={url}
      rel={noFollow ? 'no-follow' : undefined}
    >
      <div className={classes.icon}>{icon}</div>
      <div className={classes.text}>
        <Typography.ParagraphTitle textTransform="none">
          {title}
        </Typography.ParagraphTitle>
        <Typography.Caption color="muted" textTransform="none">
          {caption}
        </Typography.Caption>
      </div>
    </Button>
  );
};

export default DropdownMenuItem;
